import { makeStyles } from "tss-react/mui";

import { Theme } from "@mui/material";

export const useStyles = makeStyles()((theme: Theme) => ({
    startIcon: {
        minWidth: 18,
        display: "flex",
        justifyContent: "center",
        marginRight: theme.spacing(3),
    },
    endIcon: {
        minWidth: 18,
        display: "flex",
        justifyContent: "center",
    },
    text: {
        fontSize: 14,
        lineHeight: 1,
        color: theme.palette.emteria.text.secondary,
        flexGrow: 1,
    },
    listItemBox: {
        padding: theme.spacing(0, 3),
        "&:not(:first-of-type)": {
            marginTop: theme.spacing(1.5),
        },
        "&:first-of-type $listItem": {
            marginTop: 0,
        },
        "&.MuiTypography-body1": {
            lineHeight: 1,
        },
    },
    listItem: {
        marginTop: theme.spacing(1.5),
        borderRadius: 6,
        "&:hover": {
            backgroundColor: theme.palette.emteria.background.navigationHover,
            "& p": {
                color: theme.palette.emteria.text.primary,
            },
            "& i": {
                color: theme.palette.emteria.text.primary,
            },
        },
        "&.Mui-selected": {
            backgroundColor: theme.palette.mode === "dark" ? theme.palette.emteria.action : theme.palette.emteria.primary,
            "& p": {
                color: theme.palette.common.white,
            },
            "& i": {
                color: theme.palette.common.white,
            },
        },
        "&.Mui-selected:hover": {
            backgroundColor: theme.palette.emteria.background.navigationHover,
            "& p": {
                color: theme.palette.emteria.text.primary,
            },
            "& i": {
                color: theme.palette.emteria.text.primary,
            },
        },
        padding: theme.spacing(2.5, 3),
    },
}));
